import React from "react";
import PageWrapper from "./content_library.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import ContentLibraryShareTable from "../../components/contentLibrary/ContentLibraryShare";

const ContentLibraryShare = props => {
  return (
    <PageWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          props={props}
          title="sidebar.content_library"
          className="plr-15"
          breadCrumb={[
            {
              name: "sidebar.dashboard",
              url: "/dashboard"
            },
            {
              name: "sidebar.content_library",
              url: "/content-library"
            },
            {
              name: "action.share"
            }
          ]}
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() => props.history.push("/content-library")}
        >
          <i className="fas fa-step-backward"></i> Back
        </div>
      </div>
      <div className="user-tbl">
        <ContentLibraryShareTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    auth: state.auth
  };
};

export default connect(mapStateToProps, null)(ContentLibraryShare);
